import React, { ComponentProps } from 'react';

export default function IosShareIcon(props: ComponentProps<"svg">) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <g clipPath="url(#clip0_1314_915038)">
        <path d="M7.94271 2.5963L7.25243 3.28658L6.47951 2.51366V7.94352H5.51701V2.51366L4.7441 3.28658L4.05382 2.5963L5.99826 0.651855L7.94271 2.5963ZM9.88715 5.02686V10.3741C9.88715 10.9088 9.44965 11.3463 8.91493 11.3463H3.0816C2.54201 11.3463 2.10938 10.9088 2.10938 10.3741V5.02686C2.10938 4.48727 2.54201 4.05463 3.0816 4.05463H4.53993V5.02686H3.0816V10.3741H8.91493V5.02686H7.4566V4.05463H8.91493C9.44965 4.05463 9.88715 4.48727 9.88715 5.02686Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_1314_915038">
          <rect width="11.6667" height="11.6667" fill="white" transform="translate(0.164062 0.166504)"/>
        </clipPath>
      </defs>
    </svg>
  );
}
